import { useIntercom } from "react-use-intercom";

import NavItem from "features/layout/components/NavItem";

import { getWhitelabelCustomization } from "common/helpers/utils";

import NavItemTooltipWrapper from "./NavItemTooltipWrapper";

import IntercomIcon from "assets/icons/intercom.svg?react";

export default function ExtraNavItems({ isExpanded }: { isExpanded: boolean }) {
  const { show } = useIntercom();

  const label = "Support live chat";

  if (!getWhitelabelCustomization()) {
    return (
      <NavItemTooltipWrapper
        navItemComponent={
          <button type="button" onClick={show}>
            <NavItem isExpanded={isExpanded} icon={<IntercomIcon />}>
              {label}
            </NavItem>
          </button>
        }
        isExpanded={isExpanded}
        label={label}
      />
    );
  }
}
